<template>
  <footer class="footer">
    <div class="container">
      <div class="content has-text-centered">
        <p>
          <strong>كلمة&copy; لإدارة المحتوى {{ kalimah }} </strong><br>
          تطوير <a href="https://manzilak.com">منزلك</a>
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  data () {
    return {
      kalimah: JSON.stringify(require('../../package.json').version)
    }
  }
}
</script>
